import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import firebase from 'firebase'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD2opX5y9v9cZxeNMIEId3lqKUuT36JgyM",
  authDomain: "workoutap-82ad5.firebaseapp.com",
  projectId: "workoutap-82ad5",
  storageBucket: "workoutap-82ad5.appspot.com",
  messagingSenderId: "171829251246",
  appId: "1:171829251246:web:e0730708d547de89def13f",
  measurementId: "G-XRJLLQ11TN"
}



firebase.initializeApp(firebaseConfig)

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
